// extracted by mini-css-extract-plugin
export default {"campaignHeaderSaving":"to1VLr9OcTkrlm2SNIr4","campaignHeaderSavingLabel":"_FOLWHJs2jsEYDTOGRG9"};